// extracted by mini-css-extract-plugin
export var largeButton = "styles-module__largeButton___Cxsj6";
export var proBadge = "styles-module__proBadge___eVj87";
export var roundButtonBase = "styles-module__roundButtonBase___tPtiT";
export var smallButton = "styles-module__smallButton___cpjJ9";